import { SModel } from "servisofts-model";
import Action from "./Action";
import Reducer from "./Reducer";

export default new SModel<Action, Reducer>({
    info: {
        component: "background_location"
    },
    Columns: {
        "key": { type: "text", pk: true },
        "fecha_on": { type: "timestamp", label: "Fecha de creacion" },
        "estado": { type: "integer" },
        "latitude": { type: "double" },
        "longitude": { type: "double" },
        "key_usuario": { type: "text", fk: "usuario" }
    },

    Action,
    Reducer,
});